import React from 'react';
interface RubricProps {
  index: string;
  title: string;
  count?: string;
}
/** A numbered section header with a hairline and a mono index — the editorial spine of the doc. */
export function Rubric({
  index,
  title,
  count
}: RubricProps) {
  return <div className="keep-with-next mb-6 flex items-baseline gap-4 border-b border-[var(--ink)] pb-2.5" data-id="element-152" data-mp="2oudkkpzt3e20">
      <span className="font-mono text-[11px] tabular-nums text-[var(--accent)]" data-id="element-153" data-mp="2su4e31gpw8a8">
        {index}
      </span>
      <h2 className="flex-1 font-display text-[22px] font-normal tracking-tight text-[var(--ink)]" data-id="element-154" data-mp="2eyslp0q1atwh">
        {title}
      </h2>
      {count && <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--ink-faint)]" data-id="element-155" data-mp="25wt2q2vglfqw">
          {count}
        </span>}
    </div>;
}